import { Component, Input } from '@angular/core'
import { Customer } from '../types'
import { queueLocked } from '../logic/customer-states'
import { fullDayNoYear } from '../utils'

@Component({
  selector: 'queue-header',
  template: `
    <ng-template [ngIf]="customer?.queuedPostsCount > 0">
      <div class="bigger-than-normal-text small-bottom-buffer clearfix">
        <span class="left-or-right-depending-on-size">
          <span placement="bottom" containerClass="white-tooltip" [isDisabled]="!queueLocked()"
                tooltip="{{numberOfLockedPosts()}} of your {{customer.queuedPostsCount}} submissions are locked because you have submissions older than 30 days.">
          </span>
          <span *ngIf="customer.queuedPostsCount > customer.postCreditsCount" class="underline" placement="bottom" containerClass="white-tooltip"
                tooltip="Writers can see that you have more submissions than credits and are less likely to submit more content. Remember, an empty queue is an inviting queue.">
            Take action to receive more content.
          </span>
        </span>
      </div>
    </ng-template>
  `,
  styles: [`
    @media(max-width: 1040px) {
      .left-or-right-depending-on-size {
        float: left;
      }
    }
    @media(min-width: 1040px) {
      .left-or-right-depending-on-size {
        float: right;
      }
    }
  `]
})
export class QueueHeaderComponent {
  @Input() customer: Customer;

  formatted(date: Date): string {
    return fullDayNoYear(date)
  }

  nextPostingTime(): Date {
    return new Date(this.customer.nextPostingTime)
  }

  queueLocked(): boolean {
    return queueLocked(this.customer)
  }

  numberOfLockedPosts(): number {
    if (this.queueLocked()) {
      return this.customer.queuedPostsCount - (2 * this.customer.postsIncluded)
    } else {
      return 0
    }
  }
}
